import { render, staticRenderFns } from "./Deed.vue?vue&type=template&id=e6926ad8&scoped=true&"
import script from "./Deed.vue?vue&type=script&lang=js&"
export * from "./Deed.vue?vue&type=script&lang=js&"
import style0 from "./Deed.vue?vue&type=style&index=0&id=e6926ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6926ad8",
  null
  
)

export default component.exports